import { LookupOnSelectCallback } from '@comicrelief/component-library';
import { StyledLookup } from '../global/Global.style';
import { useLazyPostcodeLookupQuery, PostcodeLookupAddress } from '@/api/lookups/postcodeLookup';
import { inputRegex } from '@/reusableInputConfig/reusableInputConfig';

function PostcodeLookup({ onSelect }: { onSelect: LookupOnSelectCallback }) {
  const [triggerPostcodeLookup] = useLazyPostcodeLookupQuery();

  const postcodeFetcher = async (query: string) => {
    if (!query.trim()) throw new Error('Please enter a valid UK postcode');

    if (!query.match(inputRegex.UK_POSTCODE.PATTERN)) throw new Error('Please enter a valid UK postcode');

    let result;

    try {
      result = await triggerPostcodeLookup(query);
    } catch (error) {
      throw new Error('Sorry, something unexpected went wrong. Please try again or enter your address manually.');
    }

    if (!result?.data?.addresses) {
      throw new Error('No addresses found, please enter a valid UK postcode. For non-UK addresses, please use manual entry below.');
    }

    return result.data.addresses;
  };

  const postcodeMapper = (result: PostcodeLookupAddress) => {
    if (!result?.Line1 || !result?.postcode) return null;

    const output = [result.Line1, result.postcode];

    if (result?.Line2) output.splice(1, 0, result?.Line2);

    return output.join(', ');
  };

  return (
    <StyledLookup
      name="postcodeLookup"
      label="Search for a UK address by postcode"
      placeholder="E1 8QS"
      buttonText="Search"
      noResultsMessage="No addresses found. Please check your postcode or enter your address manually."
      lookupHandler={postcodeFetcher}
      mapOptionToString={postcodeMapper}
      onSelect={onSelect}
    />
  );
}

export default PostcodeLookup;
